import { render, staticRenderFns } from "./QuantityColumn.vue?vue&type=template&id=18bd0172&"
import script from "./QuantityColumn.vue?vue&type=script&lang=js&"
export * from "./QuantityColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports